export enum SystemErrors {
  InternalServerError = 'Something went wrong. Please try after some time.',
}
